"use strict";

var _slicedToArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/slicedToArray.js");
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReactImageMagnify = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var detect_it_1 = require("detect-it");
var react_1 = require("react");
var MagnifyContainerPortal_1 = require("./MagnifyContainerPortal");
var negative_space_1 = require("./lens/negative-space");
var positive_space_1 = require("./lens/positive-space");
var DefaultHint_1 = require("./hint/DefaultHint");
var lens_1 = require("./lib/lens");
var dimensions_1 = require("./lib/dimensions");
var CursorPosition_1 = require("./CursorPosition");
var InPlaceMagnifyContainer_1 = require("./InPlaceMagnifyContainer");
var styles_1 = require("./lib/styles");
var utils_1 = require("./utils");
var constants_1 = require("./constants");
var ReactImageMagnify = function ReactImageMagnify(props) {
  var _a;
  var activationInteractionHint = props.activationInteractionHint,
    _props$activationInte = props.activationInteractionMouse,
    activationInteractionMouse = _props$activationInte === void 0 ? constants_1.INTERACTIONS.hover : _props$activationInte,
    _props$activationInte2 = props.activationInteractionTouch,
    activationInteractionTouch = _props$activationInte2 === void 0 ? constants_1.INTERACTIONS.press : _props$activationInte2,
    _props$fadeDurationIn = props.fadeDurationInMs,
    fadeDurationInMs = _props$fadeDurationIn === void 0 ? 300 : _props$fadeDurationIn,
    _props$hintComponent = props.hintComponent,
    HintComponent = _props$hintComponent === void 0 ? DefaultHint_1.DefaultHint : _props$hintComponent,
    hintProps = props.hintProps,
    _props$isEnabled = props.isEnabled,
    isEnabled = _props$isEnabled === void 0 ? true : _props$isEnabled,
    _props$imageComponent = props.imageComponent,
    ImageComponent = _props$imageComponent === void 0 ? 'img' : _props$imageComponent,
    imageProps = props.imageProps,
    LensComponentProp = props.lensComponent,
    lensProps = props.lensProps,
    magnifyContainerProps = props.magnifyContainerProps,
    magnifiedImageComponent = props.magnifiedImageComponent,
    magnifiedImageProps = props.magnifiedImageProps,
    portalPropsProp = props.portalProps,
    _props$shouldUsePosit = props.shouldUsePositiveSpaceLens,
    shouldUsePositiveSpaceLens = _props$shouldUsePosit === void 0 ? false : _props$shouldUsePosit,
    style = props.style,
    rest = __rest(props, ["activationInteractionHint", "activationInteractionMouse", "activationInteractionTouch", "fadeDurationInMs", "hintComponent", "hintProps", "isEnabled", "imageComponent", "imageProps", "lensComponent", "lensProps", "magnifyContainerProps", "magnifiedImageComponent", "magnifiedImageProps", "portalProps", "shouldUsePositiveSpaceLens", "style"]);
  var isZoomClickable = activationInteractionHint === constants_1.INTERACTIONS.click;
  if (activationInteractionHint && activationInteractionMouse === constants_1.INTERACTIONS.click && ((_a = process === null || process === void 0 ? void 0 : process.env) === null || _a === void 0 ? void 0 : _a.NODE_ENV) !== 'production') {
    // eslint-disable-next-line no-console
    console.warn("[ReactImageMagnify]\n        Warning! \"activationInteractionHint\" is set to ".concat(activationInteractionHint, " and \"activationInteractionMouse\" is set to ").concat(constants_1.INTERACTIONS.click, ".\n        These are incompatible options and may beahve unexpectedly.\n        "));
  }
  ///
  /// Hooks
  ///
  var imageRef = (0, react_1.useRef)(null);
  var _ref = (0, react_1.useState)((0, utils_1.resolveSmallImage)(imageProps)),
    _ref2 = _slicedToArray(_ref, 2),
    smallImage = _ref2[0],
    setSmallImage = _ref2[1];
  var _ref3 = (0, react_1.useState)(detect_it_1.primaryInput === constants_1.INPUT_TYPE.mouse),
    _ref4 = _slicedToArray(_ref3, 2),
    isMouseDetected = _ref4[0],
    setIsMouseDetected = _ref4[1];
  var _ref5 = (0, react_1.useState)(detect_it_1.primaryInput === constants_1.INPUT_TYPE.touch),
    _ref6 = _slicedToArray(_ref5, 2),
    isTouchDetected = _ref6[0],
    setIsTouchDetected = _ref6[1];
  var _ref7 = (0, react_1.useState)(false),
    _ref8 = _slicedToArray(_ref7, 2),
    imageLoaded = _ref8[0],
    setImageLoaded = _ref8[1];
  var _ref9 = (0, react_1.useState)(isZoomClickable),
    _ref10 = _slicedToArray(_ref9, 2),
    lockedByHintInteraction = _ref10[0],
    setLockedByHintInteraction = _ref10[1];
  ///
  /// Derived data from state
  ///
  var portalProps = Object.assign(Object.assign({}, portalPropsProp), {
    placement: (portalPropsProp === null || portalPropsProp === void 0 ? void 0 : portalPropsProp.placement) || (isTouchDetected ? constants_1.MagnifiedImagePosition.OVER : constants_1.MagnifiedImagePosition.AUTO)
  });
  var isInPlaceMode = portalProps.placement === constants_1.MagnifiedImagePosition.OVER;
  var shouldShowLens = !isInPlaceMode && !isTouchDetected;
  ///
  /// Memos
  ///
  var resizeHandler = (0, react_1.useMemo)(function () {
    return function () {
      return (0, utils_1.setSmallImageDimensionState)(imageRef.current, setSmallImage, imageProps);
    };
  }, []);
  var computedEnlargedImageContainerDimensions = (0, react_1.useMemo)(function () {
    var _a, _b;
    return {
      width: (0, dimensions_1.getEnlargedImageContainerDimension)((magnifyContainerProps === null || magnifyContainerProps === void 0 ? void 0 : magnifyContainerProps.width) || constants_1.DEFAULT_MAGNIFY_CONTAINER_WIDTH, ((_a = imageRef === null || imageRef === void 0 ? void 0 : imageRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) || smallImage.width || constants_1.DEFAULT_MAGNIFY_CONTAINER_WIDTH, magnifyContainerProps === null || magnifyContainerProps === void 0 ? void 0 : magnifyContainerProps.scale, isInPlaceMode),
      height: (0, dimensions_1.getEnlargedImageContainerDimension)((magnifyContainerProps === null || magnifyContainerProps === void 0 ? void 0 : magnifyContainerProps.height) || constants_1.DEFAULT_MAGNIFY_CONTAINER_HEIGHT, ((_b = imageRef === null || imageRef === void 0 ? void 0 : imageRef.current) === null || _b === void 0 ? void 0 : _b.offsetHeight) || smallImage.height || constants_1.DEFAULT_MAGNIFY_CONTAINER_HEIGHT, magnifyContainerProps === null || magnifyContainerProps === void 0 ? void 0 : magnifyContainerProps.scale, isInPlaceMode)
    };
  }, [magnifyContainerProps, smallImage, isInPlaceMode]);
  var cursorOffset = (0, react_1.useMemo)(function () {
    return (0, lens_1.getLensCursorOffset)((0, utils_1.imageToStrictDimensions)(smallImage, imageRef), magnifiedImageProps, computedEnlargedImageContainerDimensions);
  }, [computedEnlargedImageContainerDimensions, magnifiedImageProps, smallImage]);
  ///
  /// Effects
  ///
  (0, react_1.useEffect)(function () {
    setSmallImage((0, utils_1.resolveSmallImage)(imageProps));
  }, [imageProps]);
  (0, react_1.useEffect)(function () {
    setLockedByHintInteraction(activationInteractionHint === constants_1.INTERACTIONS.click);
  }, [activationInteractionHint]);
  (0, react_1.useEffect)(function () {
    if (!(0, utils_1.isFluid)(imageProps)) {
      (0, utils_1.setSmallImageDimensionState)(imageRef.current, setSmallImage, imageProps);
      window.addEventListener('resize', resizeHandler);
    } else {
      window.removeEventListener('resize', resizeHandler);
    }
    return function () {
      return window.removeEventListener('resize', resizeHandler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imageProps, imageRef]);
  ///
  /// Handlers
  ///
  var generateHintStyle = function generateHintStyle(hintPropsStyle) {
    var hintStyle = Object.assign({}, hintPropsStyle);
    // Check and set via if-statements to prevent accidentally overriding existing
    // styles or styles that are set later
    if (lockedByHintInteraction) {
      hintStyle.cursor = 'pointer';
    }
    return hintStyle;
  };
  var handleDetectedEnvironmentChanged = function handleDetectedEnvironmentChanged(detectedInputType) {
    setIsMouseDetected(detectedInputType.isMouseDetected);
    setIsTouchDetected(detectedInputType.isTouchDetected);
  };
  var handleHintClick = function handleHintClick(e) {
    e.preventDefault();
    e.stopPropagation();
    setLockedByHintInteraction(false);
  };
  var handleHintTouchEnd = function handleHintTouchEnd(e) {
    e.preventDefault();
    e.stopPropagation();
    setLockedByHintInteraction(false);
  };
  var handleOutsideClick = function handleOutsideClick() {
    if (isZoomClickable) {
      setLockedByHintInteraction(true);
    }
  };
  var MemodImageComponent = (0, react_1.useMemo)(function () {
    return (0, jsx_runtime_1.jsx)(ImageComponent, Object.assign({}, imageProps, {
      alt: smallImage.alt,
      style: (0, styles_1.getSmallImageStyle)(smallImage, imageProps.style),
      ref: imageRef,
      onLoad: function onLoad(e) {
        if (smallImage.onLoad) {
          smallImage.onLoad(e);
        }
        if (!(0, utils_1.isFluid)(imageProps)) {
          (0, utils_1.setSmallImageDimensionState)(imageRef.current, setSmallImage, imageProps);
        }
        setImageLoaded(true);
      }
    }), void 0);
  }, [ImageComponent, imageProps, smallImage]);
  var HintComponentOrNull = activationInteractionHint === constants_1.INTERACTIONS.click || activationInteractionHint === constants_1.INTERACTIONS.hover ? (0, jsx_runtime_1.jsx)(HintComponent, Object.assign({}, hintProps, {
    hintTextMouse: (hintProps === null || hintProps === void 0 ? void 0 : hintProps.hintTextMouse) || "".concat((0, utils_1.capitalize)(activationInteractionHint), " to Zoom"),
    hintTextTouch: (hintProps === null || hintProps === void 0 ? void 0 : hintProps.hintTextTouch) || 'Long-Touch to Zoom',
    isMouseDetected: isMouseDetected,
    isTouchDetected: isTouchDetected,
    style: generateHintStyle(hintProps === null || hintProps === void 0 ? void 0 : hintProps.style),
    onClick: lockedByHintInteraction ? handleHintClick : undefined,
    onTouchEnd: lockedByHintInteraction ? handleHintTouchEnd : undefined
  }), void 0) : null;
  var LensComponent = LensComponentProp || shouldUsePositiveSpaceLens ? positive_space_1.PositiveSpaceLens : negative_space_1.NegativeSpaceLens;
  return (0, jsx_runtime_1.jsx)(CursorPosition_1.CursorPosition, Object.assign({
    shouldStopTouchMovePropagation: true,
    activationInteractionMouse: activationInteractionMouse,
    activationInteractionTouch: activationInteractionTouch,
    isEnabled: isEnabled,
    style: (0, styles_1.getContainerStyle)(smallImage, style, lockedByHintInteraction),
    onDetectedEnvironmentChanged: handleDetectedEnvironmentChanged,
    onOutsideClick: handleOutsideClick
  }, rest, {
    children: function children(_ref11) {
      var position = _ref11.position,
        isActive = _ref11.isActive,
        isPositionOutside = _ref11.isPositionOutside;
      return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
        children: [MemodImageComponent, imageLoaded && (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
          children: [HintComponentOrNull, shouldShowLens && !lockedByHintInteraction && (0, jsx_runtime_1.jsx)(LensComponent, Object.assign({
            cursorOffset: cursorOffset,
            fadeDurationInMs: fadeDurationInMs,
            isActive: isActive,
            isPositionOutside: isPositionOutside,
            position: position
          }, lensProps, {
            ref: imageRef
          }), void 0), isInPlaceMode && !lockedByHintInteraction && (0, jsx_runtime_1.jsx)(InPlaceMagnifyContainer_1.InPlaceMagnifyContainer, Object.assign({
            containerDimensions: computedEnlargedImageContainerDimensions,
            cursorOffset: cursorOffset,
            fadeDurationInMs: fadeDurationInMs,
            isActive: isActive,
            isPositionOutside: isPositionOutside,
            imageComponent: magnifiedImageComponent,
            imageProps: magnifiedImageProps,
            position: position,
            sourceImageDimensions: (0, utils_1.imageToStrictDimensions)(smallImage, imageRef)
          }, magnifyContainerProps), void 0), !isInPlaceMode && !lockedByHintInteraction && (0, jsx_runtime_1.jsx)(MagnifyContainerPortal_1.MagnifyContainerPortal, Object.assign({
            containerDimensions: computedEnlargedImageContainerDimensions,
            cursorOffset: cursorOffset,
            fadeDurationInMs: fadeDurationInMs,
            isActive: isActive,
            isPositionOutside: isPositionOutside,
            imageComponent: magnifiedImageComponent,
            imageProps: magnifiedImageProps,
            portalProps: portalProps,
            position: position,
            sourceImageDimensions: (0, utils_1.imageToStrictDimensions)(smallImage, imageRef)
          }, magnifyContainerProps, {
            ref: imageRef
          }), void 0)]
        }, void 0)]
      }, void 0);
    }
  }), void 0);
};
exports.ReactImageMagnify = ReactImageMagnify;